import React, { useMemo, useState } from 'react';
import StepShell from '../StepShell';
import LegalModal from '../../../../../components/nemonto/LegalModal';

const COUNTRY_CODES = [
  { code: '+1', label: 'US +1' },
  { code: '+44', label: 'UK +44' },
  { code: '+91', label: 'IN +91' },
  { code: '+61', label: 'AU +61' },
];

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ContactStep = ({ method, contact, setContact, onToggleMethod, onSubmit, onBack, submitting, error }) => {
  const [touched, setTouched] = useState(false);
  const [legalDoc, setLegalDoc] = useState(null);

  const openLegal = (doc) => (e) => {
    e.preventDefault();
    setLegalDoc(doc);
  };

  const isValid = useMemo(() => {
    if (method === 'email') {
      return EMAIL_RE.test(contact.email.trim());
    }
    return contact.phone.replace(/\D/g, '').length >= 7;
  }, [method, contact]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setTouched(true);
    if (!isValid) return;
    onSubmit();
  };

  return (
    <StepShell
      step={1}
      title={method === 'email' ? "What's your email?" : "What's your number?"}
      subtitle={method === 'email' ? "We'll send you a verification link" : "We'll send you a verification code"}
      onBack={onBack}
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        {method === 'email' ? (
          <div className="ob-field">
            <input
              type="email"
              className="ob-input"
              placeholder="yourname@email.com"
              value={contact.email}
              onChange={(e) => setContact({ ...contact, email: e.target.value })}
              autoFocus
            />
          </div>
        ) : (
          <div className="ob-field ob-phone-row">
            <select
              className="ob-select"
              value={contact.countryCode}
              onChange={(e) => setContact({ ...contact, countryCode: e.target.value })}
            >
              {COUNTRY_CODES.map((c) => (
                <option key={c.code} value={c.code}>{c.label}</option>
              ))}
            </select>
            <input
              type="tel"
              className="ob-input"
              placeholder="000 000 0000"
              value={contact.phone}
              onChange={(e) => setContact({ ...contact, phone: e.target.value })}
              autoFocus
            />
          </div>
        )}

        {touched && !isValid && (
          <p className="ob-error-text">
            {method === 'email' ? 'Enter a valid email address.' : 'Enter a valid phone number.'}
          </p>
        )}
        {error && <p className="ob-error-text">{error}</p>}

        <p className="ob-consent">
          {/* Opens in a modal so reading them doesn't throw away the onboarding progress. */}
          By continuing you agree to our{' '}
          <a href="/terms-of-use" onClick={openLegal('terms')}>Terms of Use</a> and{' '}
          <a href="/privacy-policy" onClick={openLegal('privacy')}>Privacy Policy</a>
        </p>
        <LegalModal doc={legalDoc} onHide={() => setLegalDoc(null)} />

        <div className="ob-spacer" />

        <button type="submit" className="ob-btn-primary" disabled={!isValid || submitting}>
          {submitting ? 'Sending…' : 'Send code'}
        </button>
        <button type="button" className="ob-link-muted" onClick={onToggleMethod}>
          Use {method === 'email' ? 'phone' : 'email'} instead
        </button>
      </form>
    </StepShell>
  );
};

export default ContactStep;
